
import { ui, useTranslationLang } from "@harea/component";
import { useLangMenuItems } from "components/layout/hooks/useLangMenuItems";

export const LanguageMenu = () => {
    const translationLang = useTranslationLang();
    const languageItems = useLangMenuItems();
    const currentLang = translationLang.lang || "en";
    const languageLabel = currentLang === "fr" ? "Choisir une langue" : "Choose language";
    const currentFlag = currentLang === "fr"
        ? "/assets/img/langs/FR.png"
        : "/assets/img/langs/GB.png";

    return (
        <ui.DropdownMenu>
            <ui.DropdownMenuTrigger asChild>
                <ui.Button
                    type="button"
                    variant="ghost"
                    size="icon"
                    data-testid="language-link"
                    aria-label={languageLabel}
                    className="!size-10 !overflow-hidden !rounded-md !p-0 hover:bg-sidebar-accent focus-visible:ring-sidebar-ring"
                >
                    <img
                        src={currentFlag}
                        alt=""
                        aria-hidden="true"
                        className="size-10 object-cover"
                    />
                </ui.Button>
            </ui.DropdownMenuTrigger>
            <ui.DropdownMenuContent
                align="end"
                className="w-48 rounded-xl border border-sidebar-border bg-sidebar text-sidebar-foreground shadow-xl shadow-black/20"
            >
                <ui.DropdownMenuLabel className="text-xs font-medium text-sidebar-foreground/70">
                    {languageLabel}
                </ui.DropdownMenuLabel>
                <ui.DropdownMenuSeparator className="bg-sidebar-border" />
                <ui.DropdownMenuRadioGroup
                    value={currentLang}
                    onValueChange={(lang) => {
                        if (lang === "fr" || lang === "en") {
                            translationLang.setLang(lang);
                        }
                    }}
                >
                    {languageItems.map((item) => (
                        <ui.DropdownMenuRadioItem
                            key={item.ke}
                            value={item.ke ?? ""}
                            className="gap-2 text-sidebar-foreground hover:border-0 hover:outline-none hover:ring-0 focus:bg-sidebar-accent focus:text-sidebar-accent-foreground"
                        >
                            <span className="flex items-center gap-2">
                                {item.startIcon}
                                <span>{item.label}</span>
                            </span>
                        </ui.DropdownMenuRadioItem>
                    ))}
                </ui.DropdownMenuRadioGroup>
            </ui.DropdownMenuContent>
        </ui.DropdownMenu>
    );
};